import classes from './AICAStatus.module.css'
import { useEffect, useState } from 'react'

import { useSelector } from 'react-redux'
import DefaultUpdater from '../../../common/DefaultUpdater'
import { getDaysDifference, getDaysDifferenceSimple } from '../../../../lib/dateScripts'
import StatusItemSelect from './StatusItemSelect'
import BodySimpleModalV3 from '../../../common/modal/BodySimpleModalV3'
import { compareSpecialityValues } from '../../../../lib/misc'

const StatusItem = ({data}) => {
    const activeCase = useSelector(state => state.case.activeCase)

    const [specialityData, setSpecialityData] = useState(null)

    useEffect(() => {
        if (activeCase && activeCase.aica_department_status) {
            setSpecialityData(activeCase.aica_department_status)
        }
    }, [activeCase])


    return <tr>
        {specialityData && <>
            <td className={`${specialityData[data.prefix + '_updated_at'] ? '' : classes.full_padding_cell}`}>
                <div className={classes.status_title}>{data.status_title}</div>
                {specialityData && <div className={classes.status_more}>
                    <span>{specialityData[data.prefix + '_kept'] ? specialityData[data.prefix + '_kept']  : 0} Kept</span> - <span className={compareSpecialityValues(specialityData[data.prefix + '_kept'], specialityData[data.prefix + '_missed']) ? classes.status_more_missed : ''}>{specialityData[data.prefix + '_missed'] ? specialityData[data.prefix + '_missed'] : 0} Missed</span>
                </div>}
            </td>
            <td className={`${specialityData[data.prefix + '_updated_at'] ? '' : classes.full_padding_cell}`}> 
                <StatusItemSelect preSelectedValue={specialityData[data.prefix + '_status']} prefix={data.prefix} aicaData={activeCase.aica_department_status}/> 
                {specialityData[data.prefix + '_updated_at'] && <div className={`${classes.status_more}`} style={{marginTop: 2}}>Idle for {Math.abs(getDaysDifferenceSimple(specialityData[data.prefix + '_updated_at']))} days</div>}      
            </td>
            <td>
                <BodySimpleModalV3 message={'Non Compliant'}>
                    <DefaultUpdater type={'checkbox'} value={specialityData[data.prefix + '_non_compliant']} name={'non_compliant'} label={'N/C'} identifier={{type: 'case_aica_department_status', field: data.prefix + '_non_compliant', type_id: null, folder: 'aica_department_status'}} extraOptions={{setStyle: 'text_small'}}/>
                </BodySimpleModalV3>
            </td>
        </>}
    </tr>
}

export default StatusItem